<template>
  <aside class="recommend-panel">
    <div class="recommend-head">
      <span>Up next</span>
      <h3>
        <span class="recommend-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M4 12h10M4 17h16"/></svg>
        </span>
        More games
      </h3>
    </div>

    <router-link
      class="recommend-card"
      v-for="game in games"
      :key="game.id"
      :to="{ name: 'Game', params: { slug: game.slug } }"
    >
      <img :src="game.image" :alt="game.name" />
      <div class="recommend-copy">
        <strong>{{ game.name }}</strong>
        <span>{{ game.flag || "arcade" }}</span>
      </div>
    </router-link>
  </aside>
</template>

<script>
export default {
  name: "GameRight",
  props: {
    games: {
      type: Array,
      default: function() {
        return []
      }
    }
  }
}
</script>

<style scoped>
.recommend-panel {
  display: grid;
  gap: 14px;
  padding: 18px;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(180deg, rgba(18, 20, 24, 0.95), rgba(8, 9, 11, 0.98));
  box-shadow: 0 18px 36px rgba(0, 0, 0, 0.24);
  position: relative;
  overflow: hidden;
}

.recommend-panel::before {
  content: "";
  position: absolute;
  inset: -30% auto auto 55%;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 153, 102, 0.12), transparent 64%);
  pointer-events: none;
}

.recommend-head span,
.recommend-copy span {
  color: rgba(226, 232, 240, 0.66);
  font: 600 11px/1.2 "Courier New", monospace;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.recommend-head h3 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
  color: #f8fafc;
  font: 700 26px/1.1 Georgia, serif;
}

.recommend-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.06);
}

.recommend-icon svg {
  width: 16px;
  height: 16px;
  stroke: currentColor;
  fill: none;
  stroke-width: 1.7;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.recommend-card {
  display: grid;
  grid-template-columns: 84px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  padding: 10px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(255, 255, 255, 0.03);
  transition: transform 0.24s ease, border-color 0.24s ease, background 0.24s ease;
}

.recommend-card:hover {
  transform: translateY(-2px);
  border-color: rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.05);
}

.recommend-card img {
  width: 84px;
  height: 84px;
  object-fit: cover;
  border-radius: 14px;
}

.recommend-copy {
  min-width: 0;
}

.recommend-copy strong {
  display: block;
  margin-bottom: 8px;
  color: #f8fafc;
  font: 700 16px/1.35 Georgia, serif;
}

@media (max-width: 960px) {
  .recommend-panel {
    padding: 14px;
    border-radius: 18px;
  }

  .recommend-head h3 {
    font-size: 22px;
  }
}

@media (max-width: 560px) {
  .recommend-card {
    grid-template-columns: 72px minmax(0, 1fr);
    gap: 10px;
    padding: 8px;
    border-radius: 14px;
  }

  .recommend-card img {
    width: 72px;
    height: 72px;
    border-radius: 12px;
  }

  .recommend-copy strong {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GameRight.vue